<aside class="sidebar-new d-flex flex-column" [class.is-collapsed]="collapsed()">

  <!-- Header: logo + usuario -->
  <header class="sidebar-new__header">
    <a [routerLink]="['/personas/list']" class="sidebar-new__logo">
      <img src="/assets/img/logo-3.png" alt="InAdvance" />
    </a>

    <div class="sidebar-new__user">
      <div class="sidebar-new__avatar" [matTooltip]="collapsed() ? userConected() : ''"
           matTooltipPosition="right">
        {{ shortname() }}
      </div>
      @if (!collapsed()) {
        <span class="sidebar-new__username text-truncate">{{ userConected() }}</span>
      }
    </div>
  </header>

  <!-- Navegación -->
  <nav class="sidebar-new__nav flex-grow-1">
    @for (item of menuItems(); track item.title) {

      <!-- Ítem simple (link directo) -->
      @if (item.type === 'link') {
        <a class="sidebar-new__link"
           [routerLink]="[item.path]"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: false }"
           [matTooltip]="collapsed() ? item.title : ''"
           matTooltipPosition="right">
          <mat-icon>{{ item.icontype }}</mat-icon>
          @if (!collapsed()) {
            <span class="sidebar-new__label">{{ item.title }}</span>
          }
        </a>
      }

      <!-- Grupo (con submenú) -->
      @else {
        <mat-expansion-panel class="sidebar-new__group"
                             hideToggle
                             [expanded]="isGroupOpen(item.title)"
                             [class.is-active]="isGroupOpen(item.title)"
                             (opened)="onGroupOpened(item.title)"
                             (closed)="onGroupClosed(item.title)">
          <mat-expansion-panel-header [matTooltip]="collapsed() ? item.title : ''"
                                      matTooltipPosition="right">
            <mat-panel-title class="sidebar-new__group-title">
              <mat-icon>{{ item.icontype }}</mat-icon>
              @if (!collapsed()) {
                <span class="sidebar-new__label">{{ item.title }}</span>
                <mat-icon class="sidebar-new__caret"
                          [class.is-open]="isGroupOpen(item.title)">expand_more</mat-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>

          @if (!collapsed()) {
            <div class="sidebar-new__submenu">
              @for (child of item.children; track child.title) {

                <!-- Subgrupo de 3er nivel -->
                @if (child.type === 'sub' && child.children) {
                  <button type="button"
                          class="sidebar-new__sublink sidebar-new__subgroup-toggle"
                          [class.active]="isSubGroupOpen(child.title)"
                          (click)="toggleSubGroup(child.title)">
                    <mat-icon class="sidebar-new__sub-icon">
                      {{ child.icontype || 'folder_open' }}
                    </mat-icon>
                    <span class="sidebar-new__label">{{ child.title }}</span>
                    <mat-icon class="sidebar-new__caret"
                              [class.is-open]="isSubGroupOpen(child.title)">expand_more</mat-icon>
                  </button>

                  @if (isSubGroupOpen(child.title)) {
                    <div class="sidebar-new__subsubmenu">
                      @for (sub of child.children; track sub.path) {
                        <a class="sidebar-new__sublink sidebar-new__subsublink"
                           [routerLink]="[sub.path]"
                           routerLinkActive="active"
                           [routerLinkActiveOptions]="{ exact: false }">
                          <mat-icon class="sidebar-new__sub-icon">
                            {{ sub.icontype || 'circle' }}
                          </mat-icon>
                          <span class="sidebar-new__label">{{ sub.title }}</span>
                        </a>
                      }
                    </div>
                  }
                }

                <!-- Acción (abre dialog) -->
                @else if (child.action) {
                  <button type="button"
                          class="sidebar-new__sublink"
                          (click)="onAction(child.action)">
                    <mat-icon class="sidebar-new__sub-icon">
                      {{ child.icontype || 'chevron_right' }}
                    </mat-icon>
                    <span class="sidebar-new__label">{{ child.title }}</span>
                  </button>
                }

                <!-- Link de navegación -->
                @else {
                  <a class="sidebar-new__sublink"
                     [routerLink]="[child.path]"
                     routerLinkActive="active"
                     [routerLinkActiveOptions]="{ exact: false }">
                    <mat-icon class="sidebar-new__sub-icon">
                      {{ child.icontype || 'chevron_right' }}
                    </mat-icon>
                    <span class="sidebar-new__label">{{ child.title }}</span>
                  </a>
                }
              }
            </div>
          }
        </mat-expansion-panel>
      }
    }
  </nav>

  <!-- Footer: ocultar sidebar + cerrar sesión (juntos) -->
  <footer class="sidebar-new__footer d-flex align-items-center"
          [class.justify-content-center]="collapsed()"
          [class.justify-content-between]="!collapsed()">
    <button mat-icon-button
            type="button"
            class="sidebar-new__footer-btn sidebar-new__collapse-toggle"
            (click)="toggleCollapse()"
            [matTooltip]="collapsed() ? 'Mostrar menú' : 'Ocultar menú'"
            matTooltipPosition="right">
      <mat-icon>{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>

    <button mat-icon-button
            type="button"
            class="sidebar-new__footer-btn sidebar-new__logout"
            (click)="onLogout()"
            [matTooltip]="logoutTooltip"
            matTooltipPosition="right">
      <mat-icon>logout</mat-icon>
    </button>
  </footer>
</aside>
